import { HttpClient } from '@angular/common/http';
import { TransferState, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentService } from '@23degrees/shared/services/env/env.service';
import { TranslateLoader } from '@ngx-translate/core';

export class TranslationsLoader implements TranslateLoader {
  transferState: TransferState = inject(TransferState);
  httpClient: HttpClient = inject(HttpClient);
  envService: EnvironmentService = inject(EnvironmentService);

  getTranslation(lang: string): Observable<any> {
    // const key = makeStateKey<string>(
    //   JSON.stringify({ name: 'getTranslation', lang: lang }),
    // );
    // if (this.transferState.hasKey(key)) {
    //   const data = this.transferState.get(key, '');
    //   return of(data as any);
    // }

    return this.httpClient.get(`${this.envService.LANGUAGE_PATH}${lang}`, { headers: { 'Cache-Control': 'no-cache', NoAuth: 'true' } });
    //.pipe(tap((data) => this.transferState.set(key, data as any)));
  }
}
